import React, { Component } from 'react';
import { Input, Modal, Button, Tabs, Row, Col, Dropdown, Icon, Menu, Collapse, Form, Select, Radio, DatePicker, Checkbox } from 'antd';
import './profile.css';
import Skeleton from 'react-loading-skeleton';
const Panel = Collapse.Panel;
const { TextArea } = Input;


class AddressInfo extends Component {

    state = {
        isInEditMode: false
    }

    changeEditMode = () => {
        this.setState({
            isInEditMode: !this.state.isInEditMode
        })
    }

    updateComponentValue = () => {
        this.setState({
            isInEditMode: false,
            // value: this.refs.theTextInput.value
        })
    }

    renderEditView = () => {
        const Option = Select.Option;
        const FormItem = Form.Item;

        return (<div className='container'>
            <Collapse defaultActiveKey={['1']} accordion bordered={false} >
                <Panel key="1" header={<div> <span className="myProfile-collapse-header"> Address Information </span> <span style={{ fontSize: '12px', color: 'grey', fontWeight: 300, marginLeft: '14px' }}>Edting...</span> </div>}>
                    <Form className='myprofile-form' style={{ display: 'block' }}>
                        <p className='widget-content-section'>
                            <Row type='flex' justify='space-between'>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Preferred Address"
                                    // {...formItemLayout}
                                    >
                                        <Select
                                            showSearch
                                            // style={{ width: 200 }}
                                            placeholder="Preferred Address"
                                        // optionFilterProp="children"
                                        // onChange={handleChange}
                                        // onFocus={handleFocus}
                                        // onBlur={handleBlur}
                                        // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            <Option value="home">Home</Option>
                                            <Option value="business">Business</Option>
                                            <Option value="seasonal">Seasonal</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Home Address Line 1"
                                    >
                                        <Input placeholder=" Home Address Line 1"
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Home Address Line 2"
                                    >
                                        <Input placeholder=" Home Address Line 2"
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Home Address Line 3"
                                    >
                                        <Input placeholder=" Home Address Line 3"
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Home City"
                                    >
                                        <Input placeholder=" Home City"
                                        // prefix={<i class="fa fa-linkedin" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Home State"
                                    // {...formItemLayout}
                                    >
                                        <Select
                                            showSearch
                                            // style={{ width: 200 }}
                                            placeholder="Home State"
                                        // optionFilterProp="children"
                                        // onChange={handleChange}
                                        // onFocus={handleFocus}
                                        // onBlur={handleBlur}
                                        // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            <Option value="AL">AL</Option>
                                            <Option value="AK">AK</Option>
                                            <Option value="AS">AS</Option>
                                            <Option value="AZ">AZ</Option>
                                            <Option value="AR">AR</Option>
                                            <Option value="AA">AA</Option>
                                            <Option value="AE">AE</Option>
                                            <Option value="AP">AP</Option>
                                            <Option value="CA">CA</Option>
                                            <Option value="CO">CO</Option>
                                            <Option value="CT">CT</Option>
                                            <Option value="DE">DE</Option>
                                            <Option value="DC">DC</Option>
                                            <Option value="FM">FM</Option>
                                            <Option value="FL">FL</Option>
                                            <Option value="GA">GA</Option>
                                            <Option value="GU">GU</Option>
                                            <Option value="HI">HI</Option>
                                            <Option value="ID">ID</Option>
                                            <Option value="IL">IL</Option>
                                            <Option value="IN">IN</Option>
                                            <Option value="IA">IA</Option>
                                            <Option value="KS">KS</Option>
                                            <Option value="KY">KY</Option>
                                            <Option value="LA">LA</Option>
                                            <Option value="ME">ME</Option>
                                            <Option value="MH">MH</Option>
                                            <Option value="MD">MD</Option>
                                            <Option value="MA">MA</Option>
                                            <Option value="MI">MI</Option>
                                            <Option value="MN">MN</Option>
                                            <Option value="MS">MS</Option>
                                            <Option value="MO">MO</Option>
                                            <Option value="MT">MT</Option>
                                            <Option value="NE">NE</Option>
                                            <Option value="NV">NV</Option>
                                            <Option value="NH">NH</Option>
                                            <Option value="NJ">NJ</Option>
                                            <Option value="NM">NM</Option>
                                            <Option value="NY">NY</Option>
                                            <Option value="NC">NC</Option>
                                            <Option value="ND">ND</Option>
                                            <Option value="MP">MP</Option>
                                            <Option value="OH">OH</Option>
                                            <Option value="OK">OK</Option>
                                            <Option value="OR">OR</Option>
                                            <Option value="PW">PW</Option>
                                            <Option value="PA">PA</Option>
                                            <Option value="PR">PR</Option>
                                            <Option value="RI">RI</Option>
                                            <Option value="SC">SC</Option>
                                            <Option value="SD">SD</Option>
                                            <Option value="TN">TN</Option>
                                            <Option value="TX">TX</Option>
                                            <Option value="UT">UT</Option>
                                            <Option value="VT">VT</Option>
                                            <Option value="VA">VA</Option>
                                            <Option value="VI">VI</Option>
                                            <Option value="WA">WA</Option>
                                            <Option value="WV">WV</Option>
                                            <Option value="WI">WI</Option>
                                            <Option value="WY">WY</Option>
                                            <Option value="NotUSA">Not in USA</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Home Province"
                                    >
                                        <Input placeholder=" Home Province"
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Home Zip"
                                    >
                                        <Input placeholder=" Home Zip"
                                        // prefix={<i class="fa fa-linkedin" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Home Country"
                                    // {...formItemLayout}
                                    >
                                        <Select
                                            showSearch
                                            // style={{ width: 200 }}
                                            placeholder="Home Country"
                                        // optionFilterProp="children"
                                        // onChange={handleChange}
                                        // onFocus={handleFocus}
                                        // onBlur={handleBlur}
                                        // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            <Option value="home">Home</Option>
                                            <Option value="business">Business</Option>
                                            <Option value="seasonal">Seasonal</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Months at Seasonal Address "
                                    >
                                        <Checkbox.Group style={{ width: '100%' }}
                                        // onChange={onChange}
                                        >
                                            <Row type='flex' justify='space-between'>
                                                <Col xs={22} sm={22} md={11} lg={11} xl={11}><Checkbox value="A">January</Checkbox></Col>
                                                <Col xs={22} sm={22} md={11} lg={11} xl={11}><Checkbox value="B">February</Checkbox></Col>
                                                <Col xs={22} sm={22} md={11} lg={11} xl={11}><Checkbox value="C">March</Checkbox></Col>
                                                <Col xs={22} sm={22} md={11} lg={11} xl={11}><Checkbox value="D">April</Checkbox></Col>
                                                <Col xs={22} sm={22} md={11} lg={11} xl={11}><Checkbox value="E">May</Checkbox></Col>
                                                <Col xs={22} sm={22} md={11} lg={11} xl={11}><Checkbox value="F">June</Checkbox></Col>
                                                <Col xs={22} sm={22} md={11} lg={11} xl={11}><Checkbox value="G">July</Checkbox></Col>
                                                <Col xs={22} sm={22} md={11} lg={11} xl={11}><Checkbox value="H">August</Checkbox></Col>
                                                <Col xs={22} sm={22} md={11} lg={11} xl={11}><Checkbox value="I">September</Checkbox></Col>
                                                <Col xs={22} sm={22} md={11} lg={11} xl={11}><Checkbox value="J">October</Checkbox></Col>
                                                <Col xs={22} sm={22} md={11} lg={11} xl={11}><Checkbox value="K">November</Checkbox></Col>
                                                <Col xs={22} sm={22} md={11} lg={11} xl={11}><Checkbox value="L">December</Checkbox></Col>
                                            </Row>
                                        </Checkbox.Group>
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Seasonal Address Line 1"
                                    >
                                        <Input placeholder=" Seasonal Address Line 1"
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Seasonal Address Line 2"
                                    >
                                        <Input placeholder=" Seasonal Address Line 2"
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Seasonal Address Line 3"
                                    >
                                        <Input placeholder=" Seasonal Address Line 3"
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Seasonal City"
                                    >
                                        <Input placeholder=" Seasonal City"
                                        // prefix={<i class="fa fa-linkedin" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Seasonal State"
                                    // {...formItemLayout}
                                    >
                                        <Select
                                            showSearch
                                            // style={{ width: 200 }}
                                            placeholder="Seasonal State"
                                        // optionFilterProp="children"
                                        // onChange={handleChange}
                                        // onFocus={handleFocus}
                                        // onBlur={handleBlur}
                                        // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            <Option value="AL">AL</Option>
                                            <Option value="AK">AK</Option>
                                            <Option value="AS">AS</Option>
                                            <Option value="AZ">AZ</Option>
                                            <Option value="AR">AR</Option>
                                            <Option value="AA">AA</Option>
                                            <Option value="AE">AE</Option>
                                            <Option value="AP">AP</Option>
                                            <Option value="CA">CA</Option>
                                            <Option value="CO">CO</Option>
                                            <Option value="CT">CT</Option>
                                            <Option value="DE">DE</Option>
                                            <Option value="DC">DC</Option>
                                            <Option value="FM">FM</Option>
                                            <Option value="FL">FL</Option>
                                            <Option value="GA">GA</Option>
                                            <Option value="GU">GU</Option>
                                            <Option value="HI">HI</Option>
                                            <Option value="ID">ID</Option>
                                            <Option value="IL">IL</Option>
                                            <Option value="IN">IN</Option>
                                            <Option value="IA">IA</Option>
                                            <Option value="KS">KS</Option>
                                            <Option value="KY">KY</Option>
                                            <Option value="LA">LA</Option>
                                            <Option value="ME">ME</Option>
                                            <Option value="MH">MH</Option>
                                            <Option value="MD">MD</Option>
                                            <Option value="MA">MA</Option>
                                            <Option value="MI">MI</Option>
                                            <Option value="MN">MN</Option>
                                            <Option value="MS">MS</Option>
                                            <Option value="MO">MO</Option>
                                            <Option value="MT">MT</Option>
                                            <Option value="NE">NE</Option>
                                            <Option value="NV">NV</Option>
                                            <Option value="NH">NH</Option>
                                            <Option value="NJ">NJ</Option>
                                            <Option value="NM">NM</Option>
                                            <Option value="NY">NY</Option>
                                            <Option value="NC">NC</Option>
                                            <Option value="ND">ND</Option>
                                            <Option value="MP">MP</Option>
                                            <Option value="OH">OH</Option>
                                            <Option value="OK">OK</Option>
                                            <Option value="OR">OR</Option>
                                            <Option value="PW">PW</Option>
                                            <Option value="PA">PA</Option>
                                            <Option value="PR">PR</Option>
                                            <Option value="RI">RI</Option>
                                            <Option value="SC">SC</Option>
                                            <Option value="SD">SD</Option>
                                            <Option value="TN">TN</Option>
                                            <Option value="TX">TX</Option>
                                            <Option value="UT">UT</Option>
                                            <Option value="VT">VT</Option>
                                            <Option value="VA">VA</Option>
                                            <Option value="VI">VI</Option>
                                            <Option value="WA">WA</Option>
                                            <Option value="WV">WV</Option>
                                            <Option value="WI">WI</Option>
                                            <Option value="WY">WY</Option>
                                            <Option value="NotUSA">Not in USA</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Seasonal Province"
                                    >
                                        <Input placeholder=" Seasonal Province"
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Seasonal Zip"
                                    >
                                        <Input placeholder=" Seasonal Zip"
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Seasonal Country"
                                    >
                                        <Input placeholder=" Seasonal Country"
                                        // prefix={<i class="fa fa-linkedin" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Business Address Line 1"
                                    >
                                        <Input placeholder=" Business Address Line 1"
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Business Address Line 2"
                                    >
                                        <Input placeholder=" Business Address Line 2"
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Business City"
                                    >
                                        <Input placeholder=" Business City"
                                        // prefix={<i class="fa fa-linkedin" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label="Business State:"
                                    // {...formItemLayout}
                                    >
                                        <Select
                                            showSearch
                                            // style={{ width: 200 }}
                                            placeholder="Select a State"
                                        // optionFilterProp="children"
                                        // onChange={handleChange}
                                        // onFocus={handleFocus}
                                        // onBlur={handleBlur}
                                        // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            <Option value="AL">AL</Option>
                                            <Option value="AK">AK</Option>
                                            <Option value="AS">AS</Option>
                                            <Option value="AZ">AZ</Option>
                                            <Option value="AR">AR</Option>
                                            <Option value="AA">AA</Option>
                                            <Option value="AE">AE</Option>
                                            <Option value="AP">AP</Option>
                                            <Option value="CA">CA</Option>
                                            <Option value="CO">CO</Option>
                                            <Option value="CT">CT</Option>
                                            <Option value="DE">DE</Option>
                                            <Option value="DC">DC</Option>
                                            <Option value="FM">FM</Option>
                                            <Option value="FL">FL</Option>
                                            <Option value="GA">GA</Option>
                                            <Option value="GU">GU</Option>
                                            <Option value="HI">HI</Option>
                                            <Option value="ID">ID</Option>
                                            <Option value="IL">IL</Option>
                                            <Option value="IN">IN</Option>
                                            <Option value="IA">IA</Option>
                                            <Option value="KS">KS</Option>
                                            <Option value="KY">KY</Option>
                                            <Option value="LA">LA</Option>
                                            <Option value="ME">ME</Option>
                                            <Option value="MH">MH</Option>
                                            <Option value="MD">MD</Option>
                                            <Option value="MA">MA</Option>
                                            <Option value="MI">MI</Option>
                                            <Option value="MN">MN</Option>
                                            <Option value="MS">MS</Option>
                                            <Option value="MO">MO</Option>
                                            <Option value="MT">MT</Option>
                                            <Option value="NE">NE</Option>
                                            <Option value="NV">NV</Option>
                                            <Option value="NH">NH</Option>
                                            <Option value="NJ">NJ</Option>
                                            <Option value="NM">NM</Option>
                                            <Option value="NY">NY</Option>
                                            <Option value="NC">NC</Option>
                                            <Option value="ND">ND</Option>
                                            <Option value="MP">MP</Option>
                                            <Option value="OH">OH</Option>
                                            <Option value="OK">OK</Option>
                                            <Option value="OR">OR</Option>
                                            <Option value="PW">PW</Option>
                                            <Option value="PA">PA</Option>
                                            <Option value="PR">PR</Option>
                                            <Option value="RI">RI</Option>
                                            <Option value="SC">SC</Option>
                                            <Option value="SD">SD</Option>
                                            <Option value="TN">TN</Option>
                                            <Option value="TX">TX</Option>
                                            <Option value="UT">UT</Option>
                                            <Option value="VT">VT</Option>
                                            <Option value="VA">VA</Option>
                                            <Option value="VI">VI</Option>
                                            <Option value="WA">WA</Option>
                                            <Option value="WV">WV</Option>
                                            <Option value="WI">WI</Option>
                                            <Option value="WY">WY</Option>
                                            <Option value="NotUSA">Not in USA</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Business Province"
                                    >
                                        <Input placeholder=" Business Province"
                                        // prefix={<i class="fa fa-twitter" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Business Zip"
                                    >
                                        <Input placeholder=" Business Zip"
                                        // prefix={<i class="fa fa-linkedin" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <FormItem
                                        label=" Business Country"
                                    >
                                        <Input placeholder=" Business Country"
                                        // prefix={<i class="fa fa-linkedin" style={{ color: 'rgba(0,0,0,.25)' }}> </i>}
                                        />
                                    </FormItem>
                                </Col>
                            </Row>
                            <hr className="line-divider-full" />
                            <Row type='flex' justify='space-around'>
                                <Col xs={23} sm={23} md={18} lg={18} xl={18}>
                                    <Row type='flex' justify='space-around'>
                                        <Col xs={22} sm={22} md={9} lg={9} xl={9}>
                                            <Button id="ap-ad-cl" className="myprofile-cancel-btn" onClick={this.changeEditMode}>Cancel</Button>
                                        </Col>
                                        <Col xs={22} sm={22} md={9} lg={9} xl={9}>
                                            <Button id="ap-su-cl" className="save-change-btn" onClick={this.updateComponentValue} type="primary">SAVE CHANGE</Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </p>
                    </Form>
                </Panel>
            </Collapse>
        </div>

        )
    }

    renderDefaultView = () => {
        return (
            <div className='container'>
                <Collapse bordered={false} >
                    <Panel header={<div className="alumni-header"> <span className="myProfile-collapse-header"> Address Information </span>
                        <span className="editing-btn"><i class="fa fa-pencil" onClick={this.changeEditMode}></i></span>
                    </div>}>
                        <p className='widget-content-section'>
                            <Row type='flex' justify='space-between'>
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'>Preferred Address</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Home Address Line 1</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Home Address Line 2</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Home Address Line 3</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Home City</label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Home State </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Home Province </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Home Zip </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Home Country </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Months at Seasonal Address </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Seasonal Address Line 1 </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Seasonal Address Line 2 </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Seasonal Address Line 3 </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Seasonal City </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Seasonal State </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Seasonal Province </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Seasonal Zip </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Seasonal Country </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Business Address Line 1 </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Business Address Line 2 </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Business City </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Business State </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Business Province </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Business Zip </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                                <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <label className='field-label'> Business Country </label>
                                </Col>
                                {/* <Col xs={22} sm={22} md={11} lg={11} xl={11}>
                                    <Skeleton />
                                </Col> */}
                            </Row>
                        </p>
                    </Panel>
                </Collapse>
            </div>
        )
    }


    render() {

        return this.state.isInEditMode ?
            this.renderEditView() :
            this.renderDefaultView()
    }
}

export default AddressInfo;


// WEBPACK FOOTER //
// ./src/components/AlumniProfile/AddressInfo.js